export default __webpack_public_path__ + "static/media/juice-headline-mobile@2x.637eae43.png";